export const lbsToKgs = (weight: number): number => weight / 2.2046

export const lbsToStones = (
  pounds: number,
): { stones: number; lbs: number } => {
  const stones = Math.floor(pounds / 14)
  const lbs = Math.round(pounds % 14)
  return { stones, lbs }
}

export const feetToInches = (feet = 0): number => 12 * feet

export const inchesToCm = (inches: number): number => inches * 2.54

export const inchesToMeters = (inches: number): number =>
  inchesToCm(inches) / 100
